<template>
    <div class="block">
        <div class="font-medium">
            {{ statusLabel }}
        </div>
        <a
            v-if="invitationLink && status === 2"
            class="truncate text-main-500 block cursor-pointer"
            :href="invitationLink"
            target="_blank">
            {{ invitationLink }}
        </a>
        <a
            v-if="status === 2"
            v-loading="inviting"
            class="truncate text-main-500 block cursor-pointer shadow"
            @click="resendInvitation">
            Gửi lại lời mời
        </a>
    </div>
</template>

<script setup lang="ts">
const store = $store()
const companyName = ref('')

const props = defineProps({
  params: {
    type: Object as PropType<any>,
    required: true
  }
})

const { params } = toRefs(props)
const paramData = computed(() => params.value.data)
const status = computed(() => paramData.value?.status)
const userId = computed(() => paramData.value?._id)
const invitationBy = computed(() => paramData.value?.invitationBy || paramData.value?.registerBy)
const inviting = ref(false)
const invitationLink = computed(() => {
  return paramData.value?.invitationLink
})
const resendInvitation = () => {
  inviting.value = true
  $api($urlClient.company.users.resendActivation, { uriParams: { ID: userId.value } })
    .then(() => {
      inviting.value = false
    })
    .catch(() => {
      inviting.value = false
    })
}
const statusLabel = computed(() => {
  if (paramData.value?.status === 1) {
    return $t('labels.active')
  }
  if (paramData.value?.status === -1 || paramData.value?.status === 0) {
    return $t('labels.inactive')
  }
  if (paramData.value?.status === 2) {
    return $t('labels.awaitingConfirmation')
  }
  return '#'
})
</script>
